import styled from 'styled-components';

export const FilterWrapper = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 18px 20px;
  margin: 16px 0;
  border: 0.4px solid #dfdfdf;
`;

export const TopFilterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.$isOpen ? '20px' : '0')};
`;

export const FilterToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid ${(props) => (props.$active ? '#2D6CDF' : '#D4D8DD')};
  background: ${(props) => (props.$active ? '#eff6ff' : '#FFFFFF12')};
  color: ${(props) => (props.$active ? '#2D6CDF' : '#212529')};
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
`;
export const FilterImg = styled.img`
  width: 18px;
`;

export const PeriodTabs = styled.div`
  display: flex;
  background: linear-gradient(
    90deg,
    rgba(219, 234, 254, 0.5) 0%,
    rgba(221, 234, 254, 0.5) 7.69%,
    rgba(223, 234, 254, 0.5) 15.38%,
    rgba(225, 234, 254, 0.5) 23.08%,
    rgba(227, 233, 254, 0.5) 30.77%,
    rgba(228, 233, 254, 0.5) 38.46%,
    rgba(230, 233, 254, 0.5) 46.15%,
    rgba(232, 233, 255, 0.5) 53.85%,
    rgba(234, 233, 255, 0.5) 61.54%,
    rgba(236, 233, 255, 0.5) 69.23%,
    rgba(238, 232, 255, 0.5) 76.92%,
    rgba(239, 232, 255, 0.5) 84.62%,
    rgba(241, 232, 255, 0.5) 92.31%,
    rgba(243, 232, 255, 0.5) 100%
  );
  padding: 8px;
  border-radius: 16px;
  gap: 4px;
  min-width: 374px;
`;

export const PeriodTab = styled.button`
  padding: 6px 20px;
  border-radius: 14px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: ${(props) => (props.$active ? '#ffffff' : 'transparent')};
  color: ${(props) => (props.$active ? '#0A0A0A' : '#0A0A0A')};
  box-shadow: ${(props) => (props.$active ? '0px 2px 4px rgba(0, 0, 0, 0.05)' : 'none')};
  flex: 1;
`;

export const ExpandedFilters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 26px;
  border-top: 1px solid #dfdfdf;
  position: relative;
`;
export const CloseImg = styled.img`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  z-index: 10;
`;

export const FilterFieldsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  > div {
    min-height: auto;
    min-width: 180px;
  }
`;

export const DateRangeGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  > div > div > div > div > div {
    height: 44px;
    margin-top: 5px;
  }
`;
export const DateRangeSpan = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #212529;
  position: absolute;
  top: -12px;
  left: 0;
`;
export const DataRangeBlock = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ClearAllButton = styled.button`
  align-self: flex-end;
  background: none;
  border: none;
  color: #212529;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px 8px;

  &:hover {
    color: #1d3557;
  }
`;
